import {captureWebsocketError} from '../utils/captureWebsocketError';
import {isAuthErrorPayload} from '../utils/isAuthErrorPayload';
import {startAuthRefresh} from './startAuthRefresh';
import type {SocketContext, SubscriptionDeps, SubscriptionState} from './subscriptionTypes';

/**
 * Called on `error` / `connection_error` frames from AppSync.
 *
 * Every error is reported to Sentry. Auth errors additionally trigger the
 * refresh self-heal — but only when the state machine is in a position to
 * act: no refresh in flight, breaker not tripped, subscription not unmounting.
 */
export const reportErrorAndMaybeRefresh = (
  payload: unknown,
  state: SubscriptionState,
  deps: SubscriptionDeps,
  ctx: SocketContext
) => {
  captureWebsocketError(payload);

  if (
    !isAuthErrorPayload(payload) ||
    state.isRefreshing ||
    state.hasStopped ||
    state.isCleaningUp
  ) {
    return;
  }

  startAuthRefresh(state, deps, ctx);
};
